import script from "./CriterionCreator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CriterionCreator.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__